import {tv} from 'tailwind-variants'

export const tableCellVariants = tv({
  slots: {
    cell: 'flex h-full w-full',
    contentWrapper: 'relative flex h-full w-full',
  },
  variants: {
    alignment: {
      start: {contentWrapper: 'justify-start text-left'},
      center: {contentWrapper: 'justify-center text-center'},
      end: {contentWrapper: 'justify-end text-right'},
    },
  },
})
